import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BackendService } from '../core/services/backend-prod.service';
import { HelperService } from '../core/services/helper.service';
import { Storage } from '@ionic/storage';
import { MenuService } from '../core/services/menu.service';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'app-activity-logs',
  templateUrl: './activity-logs.page.html',
  styleUrls: ['./activity-logs.page.scss'],
})

export class ActivityLogsPage implements OnInit {

  breadcrumbList = [
    {
      label: 'Activity Logs',
      embedurl: true,
      url: '/baseapp/activity-logs'
    }
  ];

  userActivityLogsColumns: string[] = ['first_name', 'last_name', 'action', 'visited_date', 'visited_page_url'];
  userActivityLogs: any[] = [];
  activityLogs: any[] = [];
  hide1200 = false;
  page_min = 0;
  page_max = 10;
  total_records = 0;
  payload1;
  payload2;
  sortBy: string = "";
  orderBy: string = "DESC";
  search = "";
  from_date: string = "";
  to_date: string = "";
  currentDate: Date = new Date(); // Get the current date
  loading = true;
  getActivityLogsApi: any;
  roleId
  userId: any;
  selctedUser: any;
  minDate:Date = new Date();
  constructor(

    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public menuService: MenuService,
    public alertController: AlertController,
    public helperService: HelperService,
    private _formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.helperService.getNavHelp().subscribe(toggle => {
    });
    this.getActivityLog();
    this.onActivityLogs();
  }

  clearActivityLogs() {
    this.search = "";
    this.onActivityLogs(this.search);
  }

  selectActivityLogs(e) {
    this.getActivityLog(e.value);
    this.selctedUser = e.value;
    const selectedDate = this.activityLogs.find(item=>item.id === this.selctedUser);
    if(selectedDate && selectedDate.created_date){
      const createdDate = new Date(new Date(selectedDate.created_date).toLocaleDateString())
      this.minDate = createdDate;
    }
  }

  onActivityLogs(e?) {
    this.getStorage().then((res) => {
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      this.backendService.PostAPICall('getAllUsers', payload, res.token).subscribe(
        async data => {
          let decoded_token
          await this.helperService.decode(res.token).then((d)=>{decoded_token=d})
          this.roleId = decoded_token.role.role_id;
          this.activityLogs = data.records;
          this.total_records = data.total_count;
        },
        (error) => {
          this.helperService.handleError(error);
        }
      );
    })
  }

  getActivityLog(id?) {
    this.getStorage().then(async (res) => {
      await this.helperService.loader();
      let user_id = "";
      if (id != undefined) {
        user_id = id
      }
      let fromDate = this.from_date; // Assuming that this.from_date is already a valid date string
      let toDate = this.to_date;     // Assuming that this.to_date is already a valid date string
      if (fromDate && toDate) {
        // Convert fromDate and toDate to Date objects
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);

        // Add one day to both dates
        fromDateObj.setDate(fromDateObj.getDate() + 1);
        toDateObj.setDate(toDateObj.getDate() + 1);

        fromDate = fromDateObj.toISOString(); // Updated fromDate
        toDate = toDateObj.toISOString();     // Updated toDate
      }
      let payload = {
        min: this.page_min,
        max: this.page_max,
        fromDate: fromDate,
        toDate: toDate,
        user_id: user_id
      }
      let decoded_token
      await this.helperService.decode(res.token).then((d)=>{decoded_token=d})
      this.roleId = decoded_token.role.role_id;
      if (this.roleId == 1) {
        this.getActivityLogsApi = this.backendService.PostAPICall('getAllUsersActivity', payload, res.token).subscribe(
          data => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            this.total_records = data.total_count;
            // let decoded_token = JSON.parse(atob(res.token.split('.')[1]));
            // this.roleId = decoded_token.role.role_id;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
      } else if (this.roleId == 2) {
        this.getActivityLogsApi = this.backendService.PostAPICall('getOrgUsersActivity', payload, res.token).subscribe(
          data => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            this.total_records = data.total_count;
            // let decoded_token = JSON.parse(atob(res.token.split('.')[1]));
            // this.roleId = decoded_token.role.role_id;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
      } else if (this.roleId == 3) {
        let fromDate = this.from_date; // Assuming that this.from_date is already a valid date string
        let toDate = this.to_date;     // Assuming that this.to_date is already a valid date string
        if (fromDate && toDate) {
          // Convert fromDate and toDate to Date objects
          const fromDateObj = new Date(fromDate);
          const toDateObj = new Date(toDate);

          // Add one day to both dates
          fromDateObj.setDate(fromDateObj.getDate() + 1);
          toDateObj.setDate(toDateObj.getDate() + 1);

          fromDate = fromDateObj.toISOString(); // Updated fromDate
          toDate = toDateObj.toISOString();     // Updated toDate
        }
        let payloadlog = {
          min: this.page_min,
          max: this.page_max,
          fromDate: fromDate,
          toDate: toDate
        };
        this.getActivityLogsApi = this.backendService.PostAPICall('getActivity', payloadlog, res.token).subscribe(
          (data) => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            this.total_records = data.total_count;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          });
      }
    });
  }
  
  activityLogsList($event) {
    const fromDate = new Date(this.from_date);
    const toDate = new Date(this.to_date);
    if (fromDate.getTime() === toDate.getTime()) {
      console.error('From Date and To Date cannot be the same');
      this.helperService.closeLoader();
      this.helperService.presentToast("From Date and To Date cannot be the same", 2000);
    } else {
      this.getActivityLog(this.selctedUser);
    }
  }
      

  clearLog() {
    this.selctedUser = "";
    this.from_date = "";
    this.to_date = "";
    this.loadMore(event);
  }

  loadMore(event) {
    this.helperService.loader()
    this.page_max = this.page_max + 10;
    let payload = {
      min: this.page_min,
      max: this.page_max,
      fromDate: this.from_date,
      toDate: this.to_date,
      user_id: this.selctedUser
    }
    this.getStorage().then(async (res) => {
      let decoded_token
      await this.helperService.decode(res.token).then((d)=>{decoded_token=d})
      this.roleId = decoded_token.role.role_id;
      if (this.roleId == 1) {
        this.backendService.PostAPICall('getAllUsersActivity', payload, res.token).subscribe(
          data => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            event.target.complete();
            if (data.length == this.total_records) {
              event.target.disabled = true;
            }
          },
          (error) => {
            //console.log(error);
            event.target.complete();
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
      } else if (this.roleId == 2) {
        this.backendService.PostAPICall('getOrgUsersActivity', payload, res.token).subscribe(
          data => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            event.target.complete();
            if (data.length == this.total_records) {
              event.target.disabled = true;
            }
          },
          (error) => {
            event.target.complete();
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
      } else if (this.roleId == 3) {
        let payloadlog = {
          min: this.page_min,
          max: this.page_max,
          fromDate: this.from_date,
          toDate: this.to_date
        };
        this.backendService.PostAPICall('getActivity', payloadlog, res.token).subscribe(
          data => {
            this.helperService.closeLoader();
            this.userActivityLogs = typeof data=='object'?data:[];
            event.target.complete();
            if (data.length == this.total_records) {
              event.target.disabled = true;
            }
          },
          (error) => {
            event.target.complete();
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
      }
    })
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.helperService.closeLoader();
    }, 2000);
  }
}
